import { Injectable } from "@angular/core";

@Injectable()
export class Constants {
    static vehicleYears() {
        let years = [];
        for (let i = new Date().getFullYear() + 1; i >= 1984; i--) {
            years.push({ value: i, label: i.toString() });
        }
        return years;
    }
}

export const DEFAULT_SPINNER_MESSAGE = 'Please hang tight while we build your quote...';

export const RESPONSE_CODE = {
    // Success codes
    SUCCESS: 100,
    PARTIAL_SUCCESS: 101,

    // Error codes
    UNEXPECTED_ERROR: 200,
    MISSING_PARAM: 201,
    INVALID_VALUE: 202,
    ACCESS_DENIED: 203,
    ACCOUNT_EXISTS: 204,
    INVALID_ADDRESS: 205,
    NO_PAYMENTMETHOD: 206,
    ALREADY_ASSIGNED: 207,
    INVALID_JSON: 208,
    VELOCITY_VIOLATION: 209,
    STALE_DATA: 210,
    OBSOLETE: 211,
    FEATURE_DISABLED: 212,

    JOB_ERROR: 300,
    JOB_ALREADY_CLAIMED: 301,
    SERVICE_CONSTRAINT_ERR: 302,
    JOB_CANCEL_IN_PROGRESS: 303,
    SCHEDULING_CONFLICT: 304,
    NO_AVAILABILITY: 305,
    JOB_NOT_CANCELLED: 306,
    CANT_REMOVE: 307,
    NOT_IN_SERVICE_AREA: 308,
    REQUEST_PRICING_REQUIRED: 309,
    JOB_NOT_ACTIVE: 310,
    INELIGIBLE_JOB: 311,
    INELIGIBLE_VEHICLE: 312,
    INVALID_PAYMENTMETHOD: 313,
    JOB_REQUIRES_REVIEW: 314,
    INVALID_STATUS_CHANGE: 315,
    APPROVAL_REQUIRED: 316,
    PRICING_APPROVAL_REQUIRED: 317,
    INSUFFICIENT_VEHICLE_DATA: 318,
    NO_SERVICE: 319,
    NO_DECISION: 320,

    PAYMENTMETHOD_ERROR: 400,
    PAYMENTERROR_CREATEUSER: 401,
    PAYMENTERROR_ADDMETHOD: 402,
    PAYMENTERROR_UPDATEMETHOD: 403,
    PAYMENTERROR_REMOVEMETHOD: 404,
    PAYMENTERROR_CREATETXN: 405,
    PAYMENTERROR_EXECUTETXN: 406,
    PAYMENTERROR_CAPTURE: 407,
    PAYMENTERROR_ADDMETHOD_CVV: 408,
    PAYMENTERROR_ADDMETHOD_ZIP: 409,
    PAYMENTERROR_ADDMETHOD_EXP: 410,
    PAYMENTERROR_ADDMETHOD_TYPE: 411,
    PAYMENTERROR_ADDMETHOD_NUM: 412,
    PAYMENTERROR_ADDMETHOD_CVV_EXP: 413,
    PAYMENTERROR_INUSE_JOB: 414,
    PAYMENTERROR_INUSE_MEMBERSHIP: 415,
    PAYMENTERROR_ENROLL: 416,
    PAYMENTMETHOD_VEHICLENOTDEFAULT: 417,
    PAYMENTMETHOD_VEHICLENOTUNIQUE: 418,
    PAYMENTMETHOD_REQUIRESAUTH: 419,
    PAYMENTMETHOD_AMOUNT: 420,
    PAYMENTERROR_DECLINED: 421,
    PAYMENTERROR_PENDING: 422,

    DISCOUNT_ERROR: 500,
    INELIGIBLE_REFERRAL: 501,
    INELIGIBLE_DISCOUNT: 502,

    SERVICE_ERROR: 600,
    SERVICE_NOVEHICLE: 601,
    SERVICE_NOINTERVALS: 603,

    TXN_ERROR: 700,
    TXN_CANT_CANCEL: 701,
    TXN_EXISTS: 702,
    TXN_INELIGIBLE: 703,
    TXN_REVERSAL_FAILED: 704,

    MEMBERSHIP_ERROR: 800,
    ACTIVE_MEMBERSHIP: 801,

    // Part ordering
    ORDERERROR_EPICOR: 900,
    ORDERERROR_ORDER: 901,
    ORDERERROR_INQUIRY: 902,
    ORDERERROR_CREATEPART: 903,
    ORDERERROR_CREATEPURCHASEORDER: 904,
    ORDERERROR_UPDATEPURCHASEORDER: 905,
    ORDERERROR_INVALIDVEHICLE: 906,
    ORDERERROR_MISSINGSUPPLIER: 907,
    ORDERERROR_MISSINGSERVICEMAP: 908,
};

export const JOB_STATUS = {
    NEW: 1,
    SCHEDULING: 2,
    SCHEDULED: 3,
    ENROUTE: 4,
    WORKING: 5,
    COMPLETE: 6,
    INCOMPLETE: 7,
    CLOSED: 8,
    CANCELLED: 9,
    HOLD: 15
};

export const JOB_REQUEST_STATUS = {
    READY: 1,
    PENDING: 2,
    CLAIMED: 3,
    CANCELLED: 4,
    PRICING: 5,
    PENDING_APPROVAL: 6,
    SAVED: 7,
    PENDING_PARTNER: 8,
    EXPIRED: 9
};

export const JOB_REQUEST_TYPE = {
    UNSPECIFIED: 0,
    FOLLOWUP: 1,
    ONLINE: 2,
    PHONE: 3,
    EMAIL: 4,
    DIRECT: 5,
    INSTANT: 6
};

export const JOB_REQUEST_CLASSIFICATION = {
    UNSPECIFIED: 0,
    SILVER_ROCK: 1
};

export const SERVICE_CODE_CLASSIFICATION = {
    UNSPECIFIED: 0,
    SILVER_ROCK: 1
};

export const APPROVAL_TYPE = {
    ONLINE: 1,
    PHONE: 2,
    IN_PERSON: 3,
    EMAIL: 4,
    CHAT: 5,
    SYSTEM: 6,
    OTHER: 7
};

export const MARKETING_TYPES = {
    BRAKES: 1,
    MOBILE_MECHANIC: 2,
    FLEET: 3,
    NO_START: 4,
    OIL_CHANGE: 7,
    ALTERNATOR_REPLACEMENT: 8,
    WATER_PUMP_REPLACEMENT: 9,
    DIAGNOSTIC: 10,
    STARTER_REPLACEMENT: 14,
    BATTERY_REPLACEMENT: 15,
    AC_RECHARGE: 16,
    VALVE_COVER_GASKET_REPLACEMENT: 19,
    WRENCH_ADVANTAGE: 1000
};

export const AVAILABILITY_TYPE = {
    UNKNOWN: 0,
    WRENCH: 1,
    PARTNER: 2,
    MULTIPLE: 3
};

export const PAYMENT_TYPE = {
    UNKNOWN: 0,
    CREDITCARD: 1,
    PAYPAL: 2,
    APPLEPAY: 3,
    ANDROIDPAY: 4,
    OTHER: 5,
    CASH: 6,
    DIGNIFI: 7,
    WRENCH: 10,
    PAY_LATER: 49
};

export const TRANSACTION_TYPE = {
    LABOR: 1,
    PARTS: 2,
    FIXED_PRICE: 4,
    DISCOUNT: 6,
    TAX: 9
};

export const PHOTO_TYPE = {
    UNKNOWN: 0,
    GENERAL: 1,
    CHECKLIST: 2
};

export const PHOTO_SUBJECT = {
    GENERAL: 1,
    SERVICE: 2,
    NEWPART: 3,
    OLDPART: 4,
    ENGINE: 5,
    FRONT: 6,
    REAR: 7,
    DRIVERSIDE: 8,
    PASSENGERSIDE: 9,
    ODOMETER: 10,
    TIRES: 11,
    USER_AVATAR: 12,
    CAMPAIGN: 13
};

export const MEDIA_QUERY_TYPE = {
    MIN_DESKTOP_WIDTH: 959,
    MAX_MOBILE_WIDTH: 959
};

export const CATALOG_TYPE = {
    DEFAULT: 0,
    BOTH: 1,
    REGULAR: 2,
    THIRD_SHIFT: 3
};

export interface UserEventType {
    value: number;
    label: string;
}

export const USER_EVENT_TYPE = {
    UNSUPPORTED_BROWSER: { value: 1, label: 'Unsupported Browser' },
    QUOTE_APPROVED: { value: 2, label: 'Quote Approved' },
    PAGE_LOAD: { value: 3, label: 'page load' },
    GET_QUOTE: { value: 4, label: 'get quote' },
    REQUEST_QUOTE: { value: 4, label: 'request quote' },
    LOAD_ADDONS: { value: 5, label: 'load addons' },
    CLICK: { value: 6, label: 'click' },
    SHOW_LABEL_FORM: { value: 7, label: 'show label form' },
    LOOKUP_VEHICLE: { value: 8, label: 'lookup vehicle' },
    ADD_LABEL: { value: 9, label: 'add label' },
    ADD_VEHICLE: { value: 10, label: 'add vehicle' },
    REMOVE_VEHICLE: { value: 11, label: 'remove vehicle' },
    SUBMIT: { value: 12, label: 'submit' },
    CREATE_PAYMENT_METHOD: { value: 13, label: 'create payment method' },
    NOTIFY_ME_WHEN_IN_ZIP: { value: 14, label: 'notify me when in zip' },
    REMOVE_QUOTE: { value: 15, label: 'remove quote' },
    SCHEDULE_QUOTE: { value: 16, label: 'schedule quote' },
    BOOK_QUOTE: { value: 17, label: 'book quote' },
    CHANGE: { value: 18, label: 'change' },
    CANCEL: { value: 19, label: 'cancel' },
    SELECT_APPOINTMENT: { value: 20, label: 'select appointment' },
    RATE: { value: 21, label: 'rate' },
    CLICK_STAR: { value: 22, label: 'click star' },
    GO_BACK: { value: 23, label: 'go back' },
    CREATE_ACCOUNT: { value: 24, label: 'create account' },
    ADD_DISCOUNT: { value: 25, label: 'add discount' },
    LOAD_CATALOG: { value: 26, label: 'load catalog' },
    LOOKUP_VEHICLE_MODELS: { value: 27, label: 'lookup vehicle models' },
    LOOKUP_VEHICLE_ENGINES: { value: 28, label: 'lookup vehicle engines' },
    SHOW_FORM: { value: 29, label: 'show form' },
    UNSUBSCRIBE: { value: 30, label: 'unsubscribe from marketing emails' },
    SAVE_VEHICLE_AND_PROSPECT: { value: 31, label: 'save vehicle and prospect' },
    PROSPECT_NEEDS_ACTIVATION: { value: 32, label: 'prospect needs activation' },
    SEND_EMAIL: { value: 33, label: 'send email' },
    SCHEDULE_APPOINTMENT: { value: 34, label: 'schedule appointment' },
    SELECT_LOCATION: { value: 35, label: 'select location from dropdown' },
    ADD_LOCATION: { value: 36, label: 'add location' },
    UPDATE_ACCOUNT: { value: 37, label: 'update account' },
    BOOK: { value: 38, label: 'book a job' },
    OPEN_REPORT: { value: 39, label: 'open report' },
    UPDATE_LOCATION: { value: 40, label: 'update location' },
    UPDATE_PHONE: { value: 41, label: 'update phone' },
    REMOVE_PAYMENT_METHOD: { value: 42, label: 'remove payment method' },
    REMOVE_LOCATION: { value: 43, label: 'remove location' },
    CANCEL_MEMBERSHIP: { value: 44, label: 'cancel membership' },
    GET_PROMO_DETAILS: { value: 45, label: 'get promo details' },
    SAVE_PROMO_CODE: { value: 46, label: 'save promo code' },
    LOGIN: { value: 47, label: 'login' },
    NEW_USER_SCHEDULE_QUOTE: { value: 48, label: 'new user schedule quote' },
    NEW_USER_ADD_DISCOUNT: { value: 49, label: 'new user add discount' },
    NEW_USER_ADD_LOCATION: { value: 50, label: 'new user add location' },
    NEW_USER_SAVE_LOCATION: { value: 51, label: 'new user save location' },
    NEW_USER_BOOK_APPOINTMENT: { value: 52, label: 'new user book appointment' },
    LOOKUP_ZIP: { value: 53, label: 'look up zip' },
    UPDATE_QUOTE: { value: 54, label: 'update quote' },
    CANCEL_APPOINTMENT: { value: 55, label: 'cancel appointment' },
    GET_VEHICLES: { value: 56, label: 'get vehicles' },
    NEW_VEHICLE: { value: 57, label: 'new vehicle' },
    COMING_SOON: { value: 58, label: 'Coming Soon Promotion Prospect' },
    LOAD_SCHEDULE: { value: 59, label: 'load schedule' },
    SAVE_PROSPECT: { value: 60, label: 'save prospect' },
    GET_SKU: { value: 61, label: 'get sku' },
    NEXT_COMPONENT: { value: 62, label: 'next component' },
    GET_AUTHED_QUOTE: { value: 63, label: 'existing user get quote' },
    SET_NOTIFICATION_PREFERENCES: { value: 64, label: 'save notification preferences' },
    FLEET_ACCEPT_QUOTE: { value: 65, label: 'accept quote' },
    FLEET_REJECT_QUOTE: { value: 66, label: 'reject quote' },
    FLEET_SAVE_QUOTE: { value: 67, label: 'save quote' },
    SHOW_LOGIN_MODAL: { value: 68, label: 'show login modal' },
    SHOW_SIGNUP_MODAL: { value: 69, label: 'show signup modal' },
    SIGNUP: { value: 70, label: 'signup' },
    CLOSE_LOGIN_MODAL: { value: 71, label: 'close login modal' },
    CLOSE_SIGNUP_MODAL: { value: 72, label: 'close signup modal' },
    SHOW_RESET_QUOTE: { value: 73, label: 'show reset quote warning' },
    CLOSE_RESET_QUOTE: { value: 74, label: 'close reset quote warning' },
    RESET_QUOTE: { value: 75, label: 'reset quote' },
    SELECT_VEHICLE_YEAR: { value: 76, label: 'select vehicle year' },
    SELECT_VEHICLE_MAKE: { value: 76, label: 'select vehicle make' },
    SELECT_VEHICLE_MODEL: { value: 76, label: 'select vehicle model' },
    SELECT_VEHICLE_TRIM: { value: 76, label: 'select vehicle trim' },
    SELECT_VEHICLE_ENGINE: { value: 76, label: 'select vehicle engine' },
    SELECT_VEHICLE_TRANSMISSION: { value: 76, label: 'select vehicle transmission' },
    SELECT_VEHICLE_DRIVETRAIN: { value: 76, label: 'select vehicle drivetrain' },
    SELECT_LICENSE_YEAR: { value: 76, label: 'select license year' },
    LICENSE_LOOKUP: { value: 77, label: 'vehicle lookup via license' },
    VIN_LOOKUP: { value: 78, label: 'vehicle lookup via vin' },
    MAKE_MODEL_YEAR_TAB: { value: 79, label: 'show make/model/year tab' },
    SHOW_LICENSE_LOOKUP: { value: 80, label: 'show license lookup' },
    SHOW_VIN_LOOKUP: { value: 81, label: 'show vin lookup' },
    VEHICLES_TAB: { value: 82, label: 'show your vehicles tab' },
    EDIT_VEHICLE_DETAILS: { value: 83, label: 'edit vehicle details' },
    CANCEL_EDIT_VEHICLE: { value: 84, label: 'cancel edit vehicle details' },
    UPDATE_VEHICLE: { value: 85, label: 'update vehicle' },
    CLICK_VEHICLE_NEXT: { value: 85, label: 'click vehicle next' },
    SELECT_VEHICLE: { value: 86, label: 'select vehicle from dropdown' },
    VALIDATE_LOCATION: { value: 87, label: 'validate location' },
    CREATE_PROSPECT: { value: 88, label: 'create prospect' },
    STAGE_AND_CLOSE_VEHICLE_EDIT: { value: 89, label: 'click save on vehicle edit, close modal, and stage for saving' },
    CLICK_FORGOT_PASSWORD: { value: 90, label: 'click forgot password' },
    NO_SERVICES_SELECTED: { value: 91, label: 'cannot add jobRequest, no services selected' },
    CANNOT_UPDATE_VEHICLE: { value: 92, label: 'cannot update vehicle' },
    ADD_CONTACT: { value: 93, label: 'add contact to jobRequest' },
    ADD_NEW_CONTACT: { value: 94, label: 'add new contact' },
    FLEET_GET_INVOICE: { value: 95, label: 'get invoice' },
    FLEET_GET_INVOICES: { value: 96, label: 'get invoices' },
    GET_LANDING_PAGE_DETAILS: { value: 97, label: 'get landing page details' },
    UPDATE_JOB_REQUEST_STATUS: { value: 98, label: 'update job request status' },
    UPDATE_PHOTOS: { value: 99, label: 'update photos' },
    DELETE_PHOTO: { value: 100, label: 'remove photo' },
    GET_PHOTO_CREDENTIALS: { value: 101, label: 'get photo credentials' },
    SAVE_PHOTOS: { value: 102, label: 'save photos' },
    GET_PHOTOS: { value: 103, label: 'get photos' },
    NONCE_FAILED: { value: 104, label: 'braintree nonce failed' },
    APPROVE_PRICE: { value: 105, label: 'approve price' },
    SHOW_PROSPECT_FORMS: { value: 106, label: 'show prospect forms' },
    CLICK_SEARCH_INPUT: { value: 107, label: 'click search input' },
    SELECT_SERVICE: { value: 108, label: 'select service' },
    CLOSE_SERVICES: { value: 109, label: 'close services component' },
    SELECT_ADD_ON: { value: 110, label: 'select add on' },
    UNSELECT_ADD_ON: { value: 111, label: 'unselect add on' },
    UNSELECT_SERVICE: { value: 112, label: 'unselect service' },
    DELETE_SERVICE: { value: 113, label: 'delete service' },
    SELECT_SERVICE_OPTION: { value: 114, label: 'select option' },
    CLICK_FORM: { value: 115, label: 'click form' },
    ADD_SERVICES: { value: 116, label: 'click add more services' },
    ADD_PHOTO: { value: 117, label: 'click add photo' },
    CLICK_NEW_LOCATION: { value: 118, label: 'click new location' },
    GET_JOB_REQUEST: { value: 119, label: 'get job request' },
    SELECT_PARKING_TYPE: { value: 120, label: 'select parking type' },
    RESET_VEHICLE_SELECTION: { value: 121, label: 'reset vehicle selection' },
    GET_AVAILABILITY: { value: 122, label: 'get availability' },
    SELECT_DAY: { value: 123, label: 'select day from calendar' },
    SELECT_TIME: { value: 124, label: 'select time from calendar' },
    SELECT_FLEXIBLE_SCHEDULING: { value: 125, label: 'select flexible scheduling' },
    UNSELECT_FLEXIBLE_SCHEDULING: { value: 126, label: 'unselect flexible scheduling' },
    SELECT_PAYMENT_TYPE: { value: 127, label: 'select payment type' },
    CLICK_NEW_PAYMENT: { value: 128, label: 'click new payment' },
    UPDATE_JOB_REQUEST: { value: 129, label: 'update job request' },
    CREATE_JOB_REQUEST: { value: 130, label: 'create job request' },
    GET_CATALOG_AUTHED: { value: 131, label: 'get catalog authed' },
    GET_CATALOG_UNAUTHED: { value: 132, label: 'get catalog unauthed' },
    CLOSE_MODAL: { value: 133, label: 'close modal' },
    SELECT_AUTOCOMPLETE_LOCATION: { value: 134, label: 'select autocomplete location' },
    GET_PAYMENT_METHODS: { value: 135, label: 'get payment methods' },
    SELECT_LOCATION_TYPE: { value: 136, label: 'select location type' },
    CREATE_USER: { value: 137, label: 'create user' },
    ADD_SHARED_LOCATION: { value: 138, label: 'add shared location' },
    CLOSE_BANNER: { value: 139, label: 'close banner' },
    SHOW_PROMO_CODE_FORM: { value: 140, label: 'show promo code form' },
    SHOW_PRICE_BREAKDOWN: { value: 141, label: 'show price breakdown' },
    SHOW_PHOTOS_MODAL: { value: 142, label: 'show photos modal' },
    SCROLL_PHOTO: { value: 143, label: 'scroll photo' },
    CANCEL_DELETE_PHOTO: { value: 144, label: 'cancel delete photo' },
    SHOW_PHOTO: { value: 145, label: 'show photo' },
    SELECT_CONTACT: { value: 146, label: 'select contact' },
    NEW_CONTACT: { value: 147, label: 'new contact' },
    CANCEL_NEW_CONTACT: { value: 148, label: 'cancel new contact' },
    CANCEL_RESET_QUOTE: { value: 149, label: 'cancel reset quote' },
    SELECT_LICENSE_STATE: { value: 150, label: 'select license state' },
    OPEN_EXPANSION_PANEL: { value: 151, label: 'open expansion panel' },
    CLOSE_EXPANSION_PANEL: { value: 152, label: 'close expansion panel' },
    CLICK_I_DONT_KNOW_BUTTON: { value: 153, label: 'click "i dont know" button' },
    CANCEL_I_DONT_KNOW_BUTTON: { value: 154, label: 'cancel "i dont know" modal' },
    PREVIOUS_COMPONENT: { value: 155, label: 'previous component' },
    SUBMIT_TIRES: { value: 156, label: 'submit new tires or flat tires form' },
    CLICK_NEXT_TIRES: { value: 157, label: 'use next button in new tires or flat tires form' },
    CLICK_TIRE_WHEEL_LOCK: { value: 158, label: 'select tire wheel lock option' },
    CLICK_TIRE_URGENCY: { value: 159, label: 'select tire urgency option' },
    CLICK_TIRE_LOCATION: { value: 160, label: 'select tire location option' },
    CLICK_TIRE_SIZE: { value: 161, label: 'select tire size option' },
    CLICK_TIRE_TREAD: { value: 162, label: 'select tire tread option' },
    CLICK_WARNING_OK: { value: 163, label: 'click ok on warning' },
    CLICK_WARNING_CANCEL: { value: 164, label: 'click cancel on warning' },
    DECLINE_VIN_LICENSE_OFFER: { value: 165, label: 'click No Thanks for vin-license discount' },
    DECLINE_VIN_LICENSE_LOOKUP: { value: 166, label: 'click Decline Lookup' },
    ACCEPT_VIN_LICENSE_LOOKUP: { value: 167, label: 'click Accept Lookup' },
    CONTINUE_FROM_VIN_LICENSE_MODAL: { value: 168, label: 'click Continue after price returned' },
    OPEN_VIN_LICENSE_MODAL: { value: 169, label: 'vin-license modal opened' },
    CLOSE_VIN_LICENSE_MODAL: { value: 170, label: 'vin-license modal closed' },
    CLICK_MESSAGE_OK: { value: 171, label: 'click ok on message' },
    TRANSFER_VEHICLES: { value: 172, label: 'transfer vehicles to another user' },
    UPDATE_PAYMENT_METHOD: { value: 173, label: 'update payment methods' },
    NEW_USER_BOOKED_JOB: { value: 174, label: 'new user booked a job' },
    NEW_USER_CUSTOM_QUOTE: { value: 175, label: 'new user requested a custom quote' },
    NEW_USER_ESTIMATE: { value: 176, label: 'new user saw estimate' },
    EXISTING_USER_BOOKED_JOB: { value: 177, label: 'existing user booked a job' },
    EXISTING_USER_CUSTOM_QUOTE: { value: 178, label: 'existing user requested a custom quote' },
    EXISTING_USER_ESTIMATE: { value: 179, label: 'existing user saw estimate' },
    APPLY_PAYMENT: { value: 180, label: 'apply payment to invoice or job' },
    VIEW_TRANSACTIONS: { value: 181, label: 'view transactions for a job' },
    ADD_VEHICLE_TAB: { value: 182, label: 'click add vehicle tab' },
    CLICK_DIAG_WIZARD_ANSWER: { value: 183, label: '' },
    USER_SEARCH_TEXT: { value: 184, label: 'search entry' },
    LOAD_CATALOG_SEARCH_TAGS: { value: 185, label: 'get catalog search tags' },
    FIND_JOBS: { value: 186, label: 'get jobs' },
    SHOW_REMOVE_VEHICLE_WARNING: { value: 187, label: 'show remove vehicle warning' },
    NEXT_VEHICLE_PAGE: { value: 188, label: 'next vehicle page' },
    GET_USER_DATA: { value: 189, label: 'get user data' },
    SHOW_ADD_VEHICLE_MODAL: { value: 190, label: 'show add vehicle modal' },
    SHOW_SERVICE_HISTORY_REPORT: { value: 191, label: 'show service history report' },
    UPDATE_USER_STATUS: { value: 192, label: 'update user status' },
    CREATE_JOB_REQUESTS: { value: 193, label: 'create job requests' },
    JSON_PARSE: { value: 193, label: 'parse json' },
    FIND_JOB_REQUESTS: { value: 194, label: 'find job requests' },
    SEND_JR_TO_QUOTE_FLOW: { value: 195, label: 'send job request to quote flow' },
    CLICK_BOOK_APPOINTMENT: { value: 196, label: 'click book appointment' },
    GET_JOB_NOTES: { value: 197, label: 'get job notes' },
    SHOW_SCHEDULE: { value: 198, label: 'show schedule' },
    SELECT_DAY_AND_TIME: { value: 199, label: 'select day and time' },
    CLICK_TIRE_AMOUNT: { value: 200, label: 'select tire size' },
    CLICK_TIRE_PREFERENCE: { value: 201, label: 'select tire tread option' },
    FROM_PRODUCT_PAGE: { value: 202, label: 'entered with query params ' },
    GET_LATEST_CHECKLISTS: { value: 203, label: 'get latest checklists' },
    CLICK_TIRES_BANNER: { value: 204, label: 'click tires banner' },
    CLICK_TIRES_STRIPE: { value: 205, label: 'click tires stripe' },
    GET_COMMUNICATION_OPTIONS: { value: 206, label: 'get communication options' },
    GET_COMMUNICATION_PREFERENCES: { value: 207, label: 'get communication preferences' },
    UPDATE_COMMUNICATION_PREFERENCES: { value: 208, label: 'update communication preferences' },
    SHOW_SERVICE_IN_DIAG_WIZARD: { value: 209, label: 'show service within diag wizard modal' },
    CLICK_BACK_ON_SERVICE_IN_DIAG_WIZARD: { value: 210, label: 'clicked back from service, returning to diag wizard' },
    CLICK_CAR_WONT_START: { value: 211, label: 'clicked car won\'t start service' },
    CLICK_DIAG: { value: 212, label: 'clicked diagnostic service' },
    CANCEL_CAR_WONT_START: { value: 213, label: 'canceled car won\'t start service' },
    CANCEL_DIAG: { value: 214, label: 'cancelled diagnostic service' },
    GET_LOCATION: { value: 215, label: 'get location' },
    CLICK_TIRE_PROVIDER: { value: 216, label: 'select tire provider' },
    CLICK_CONTACT_INFO: { value: 217, label: 'select preferred contact method' },
    OOA_USER_ENTERED_WITH_ZIP: { value: 218, label: 'ooa user entered with zip' },
    OPEN_OUT_OF_AREA_GET_QUOTE: { value: 219, label: 'open get out of area quote modal' },
    CLOSE_OUT_OF_AREA_GET_QUOTE: { value: 220, label: 'close get out of area quote modal' },
    AUTO_SHOPS_ERROR: { value: 221, label: 'error retrieving shops' },
    ADD_ESTIMATE_ERROR_EXISTING_OOA_USER: { value: 222, label: 'add estimate failure for existing ooa user' },
    ADD_ESTIMATE_ERROR_NEW_OOA_USER: { value: 223, label: 'add estimate failure for new ooa user' },
    OOA_USER_SIGNUP_WITH_EXISTING_EMAIL: { value: 224, label: 'ooa user entered email that is in use' },
    OOA_EMAIL_FIELD_CLICKED: { value: 225, label: 'ooa email clicked' },
    OOA_EMAIL_FIELD_BLUR: { value: 226, label: 'ooa email field blur' },
    OOA_SHOP_PHONE_CLICKED: { value: 227, label: 'ooa shop phone clicked' },
    OOA_UNPRICED_QUOTE: { value: 228, label: 'ooa user unpriced quote' },
    OOA_USER_SIGNED_UP: { value: 229, label: 'ooa user signed up' },
    VERIFY_PAYMENT_METHOD: { value: 230, label: 'verify payment method' },
    GET_MARKET: { value: 231, label: 'get market api call' },
    SHOW_DIGNIFI_MODAL: { value: 232, label: 'open dignifi modal' },
    SELECT_DIGNIFI_FINANCING: { value: 233, label: 'select dignifi financing' },
    DECLINE_VIN_LICENSE_REQUIRED_LOOKUP: { value: 234, label: 'click Decline Lookup' },
    ACCEPT_VIN_LICENSE_REQUIRED_LOOKUP: { value: 235, label: 'click Accept Lookup' },
    CONTINUE_FROM_VIN_LICENSE_REQUIRED_MODAL: { value: 236, label: 'click Continue after price returned' },
    OPEN_VIN_LICENSE_REQUIRED_MODAL: { value: 237, label: 'vin-license required modal opened' },
    CLOSE_VIN_LICENSE_REQUIRED_MODAL: { value: 238, label: 'vin-license required modal closed' },
    CLICK_CUSTOM_QUOTE_BUTTON: { value: 239, label: 'click get custom quote button' },
    GET_ALL_JOBS: { value: 239, label: 'get all jobs for user' },
    GET_BOOKING_HOURS: { value: 240, label: 'get booking hours' },
    SERVICE_SCHEDULER: { value: 241, label: 'service scheduler' },
    VIEW_LEMON_SQUAD_REPORT_PDF: { value: 242, label: 'download lemon squad report pdf' },
    SHOW_AUTO_SHOPS: { value: 243, label: 'showing shops' },
    GET_APPLICATION_CONSTANTS: { value: 244, label: 'get application constants' },
    CLICK_APPROVALS_QUOTE_ON: { value: 245, label: 'click fleet quote approvals on' },
    CLICK_APPROVALS_QUOTE_OFF: { value: 246, label: 'click fleet quote approvals off' },
    CLICK_APPROVALS_QUOTE_LIMIT: { value: 247, label: 'click fleet quote approvals limit' },
    CLICK_APPROVALS_PRICE_INC_ON: { value: 248, label: 'click fleet price increase approvals on' },
    CLICK_APPROVALS_PRICE_INC_OFF: { value: 249, label: 'click fleet price increase approvals off' },
    CLICK_APPROVALS_PRICE_INC_LIMIT: { value: 250, label: 'click fleet price increase approvals limit' },
    CLICK_APPROVALS_SERVICE_EXCEPTION: { value: 251, label: 'click fleet approvals service exception' },
    CLICK_APPROVALS_UPDATE: { value: 252, label: 'click fleet approvals update' },
    CLICK_APPROVALS_CANCEL: { value: 253, label: 'click fleet approvals cancel' },
    SELECT_STATE: { value: 254, label: 'select state' },
    UPDATE_USER: { value: 255, label: 'update user' },
    GET_LOCATIONS: { value: 256, label: 'get locations' },
    CLICK_PRICE_BREAKDOWN_PRINT: { value: 258, label: 'click price breakdown print' },
    CLICK_PRICE_BREAKDOWN_CLOSE: { value: 259, label: 'click price breakdown close' },
    CLICK_UCI_STRIPE: { value: 260, label: 'click UCI stripe' },
    CLICK_TOWING_SERVICE: { value: 261, label: 'open towing service' },
    VALIDATE_LOCATION_ZIPCHECK: { value: 262, label: 'validate location from zipcheck' },
    OOA_USER_ENTERED_WITH_ZIP_ZIPCHECK: { value: 263, label: 'ooa user entered with zip from zipcheck' },
    FORGOT_PASSWORD: { value: 264, label: 'forgot password request' },
    RESET_LOGIN: { value: 265, label: 'reset login credentials' },
    CLICK_BATTERY_STRIPE: { value: 266, label: 'click battery stripe' },
    CLICK_GET_ME_OUTTA_HERE: { value: 267, label: 'click get me outta here' },
    CHECK_MBS_AVAILABILITY: { value: 269, label: 'check mbs availability' },
    GET_DIAG_DECISION: { value: 270, label: 'get diag decision' },
    GET_DIAG_GRAPH: { value: 271, label: 'get diag graph' },
    UPDATE_AD_CHANNEL: { value: 272, label: 'update ad channel' },
    DYNAMIC_COMPONENT_ERROR: { value: 273, label: 'incorrect service expected to be dynamic' },
    GET_SERVICE_BUNDLES: { value: 274, label: 'get service bundles' },
    GET_SERVICE_BUNDLES_AUTHED: { value: 275, label: 'get service bundles authed' },
    GET_MAINTENANCE_SERVICES: { value: 276, label: 'get maintenance services' },
    GET_BULK_JR_GROUPS: { value: 277, label: 'get bulk job request groups' },
    GET_BULK_AVAILABILITY: { value: 278, label: 'get bulk availability' },
    SCHEDULE_JOB_REQUESTS: { value: 279, label: 'schedule job requests appointment group' },
    UNSCHEDULE_JOB_REQUESTS: { value: 280, label: 'unschedule job requests appointment group' },
    CLICK_USED_CAR_INSPECTION_SERVICE: { value: 281, label: 'click used car inspection service' },
    LOOKUP_VEHICLES: { value: 282, label: 'lookup vehicles' },
    UPDATE_VEHICLE_STATUS: { value: 283, label: 'update vehicle status' },
    ADD_VEHICLES: { value: 284, label: 'add vehicles' },
    GET_PAYMENT_TYPES: { value: 285, label: 'get payment types' },
    ADD_REFERRAL: { value: 286, label: 'add referral' },
    GET_PARTNER_ID: { value: 287, label: 'get partner id' },
    CHECK_YM_ZIP: { value: 288, label: 'check zip for yourmechanic serviceability' },
    CHECK_LS_ZIP: { value: 289, label: 'check zip for lemonsquad serviceability' },
    ADD_SUB_ACCOUNT: { value: 290, label: 'add sub account' },
    GET_VEHICLE_MAKES: { value: 291, label: 'get vehicle makes' },
    RESET_PASSWORD_REQUIRED: { value: 292, label: 'SSO reset password required' },
    CHECK_ACCOUNT_EXISTS: { value: 293, label: 'check account exists in wrench DB' },
    GET_REGIONS: { value: 294, label: 'get regions' },
    UPDATE_REGION: { value: 295, label: 'update region'},
    ADD_REGION: { value: 296, label: 'add region'},
    GET_HUBS: { value: 297, label: 'get hubs' },
    UPDATE_HUB: { value: 298, label: 'update hub'},
    ADD_HUB: { value: 299, label: 'add hub'},
    FIND_WORK_ORDERS: { value: 300, label: 'find work orders' },
    FIND_HUBS: { value: 301, label: 'find hubs' },
    FIND_REGIONS: { value: 302, label: 'find regions' },
    GET_CLIENT_TOKEN: { value: 303, label: 'get client token' },
    IMPORT_EMPLOYEES: { value: 304, label: 'import employees' },
    FIND_ROLES: { value: 305, label: 'find roles'},
    GET_PPMS: { value: 306, label: 'get pre paid maintenance'},
    GET_JOB_TRACE: { value: 307, label: 'get job trace'},
    GET_MECHANIC_PROFILE: { value: 308, label: 'get mechanic profile'},
    FETCH_VEHICLE: { value: 309, label: 'fetch vehicle'},
    RESCHEDULE_JOB: { value: 310, label: 'reschedule job'},
    BOOKING_FLOW_REFERRAL: { value: 311, label: 'booking flow referral'},
    EXISTING_USER_LOGIN_PROMPT_BOOKING_FLOW: { value: 312, label: 'existing user login prompt booking flow'}

};

export const PREMIUM_ADVANTAGE_SKU = 116;
export const PREMIUM_ADVANTAGE_MEMBERSHIP_CODE = 1002;

export const FORM_HELPER = {
    states: [
        { value: "AL", label: "AL", label2: "Alabama" },
        { value: "AK", label: "AK", label2: "Alaska" },
        { value: "AZ", label: "AZ", label2: "Arizona" },
        { value: "AR", label: "AR", label2: "Arkansas" },
        { value: "CA", label: "CA", label2: "California" },
        { value: "CO", label: "CO", label2: "Colorado" },
        { value: "CT", label: "CT", label2: "Connecticut" },
        { value: "DC", label: "DC", label2: "District of Columbia" },
        { value: "DE", label: "DE", label2: "Delaware" },
        { value: "FL", label: "FL", label2: "Florida" },
        { value: "GA", label: "GA", label2: "Georgia" },
        { value: "HI", label: "HI", label2: "Hawaii" },
        { value: "ID", label: "ID", label2: "Idaho" },
        { value: "IL", label: "IL", label2: "Illinois" },
        { value: "IN", label: "IN", label2: "Indiana" },
        { value: "IA", label: "IA", label2: "Iowa" },
        { value: "KS", label: "KS", label2: "Kansas" },
        { value: "KY", label: "KY", label2: "Kentucky" },
        { value: "LA", label: "LA", label2: "Louisiana" },
        { value: "ME", label: "ME", label2: "Maine" },
        { value: "MD", label: "MD", label2: "Maryland" },
        { value: "MA", label: "MA", label2: "Massachusetts" },
        { value: "MI", label: "MI", label2: "Michigan" },
        { value: "MN", label: "MN", label2: "Minnesota" },
        { value: "MS", label: "MS", label2: "Mississippi" },
        { value: "MO", label: "MO", label2: "Missouri" },
        { value: "MT", label: "MT", label2: "Montana" },
        { value: "NE", label: "NE", label2: "Nebraska" },
        { value: "NV", label: "NV", label2: "Nevada" },
        { value: "NH", label: "NH", label2: "New Hampshire" },
        { value: "NJ", label: "NJ", label2: "New Jersey" },
        { value: "NM", label: "NM", label2: "New Mexico" },
        { value: "NY", label: "NY", label2: "New York" },
        { value: "NC", label: "NC", label2: "North Carolina" },
        { value: "ND", label: "ND", label2: "North Dakota" },
        { value: "OH", label: "OH", label2: "Ohio" },
        { value: "OK", label: "OK", label2: "Oklahoma" },
        { value: "OR", label: "OR", label2: "Oregon" },
        { value: "PA", label: "PA", label2: "Pennsylvania" },
        { value: "RI", label: "RI", label2: "Rhode Island" },
        { value: "SC", label: "SC", label2: "South Carolina" },
        { value: "SD", label: "SD", label2: "South Dakota" },
        { value: "TN", label: "TN", label2: "Tennessee" },
        { value: "TX", label: "TX", label2: "Texas" },
        { value: "UT", label: "UT", label2: "Utah" },
        { value: "VT", label: "VT", label2: "Vermont" },
        { value: "VA", label: "VA", label2: "Virginia" },
        { value: "WA", label: "WA", label2: "Washington" },
        { value: "WV", label: "WV", label2: "West Virginia" },
        { value: "WI", label: "WI", label2: "Wisconsin" },
        { value: "WY", label: "WY", label2: "Wyoming" }
    ],
    months: [
        { value: 1, label: "Jan", label2: "January" },
        { value: 2, label: "Feb", label2: "February" },
        { value: 3, label: "Mar", label2: "March" },
        { value: 4, label: "Apr", label2: "April" },
        { value: 5, label: "May", label2: "May" },
        { value: 6, label: "Jun", label2: "June" },
        { value: 7, label: "Jul", label2: "July" },
        { value: 8, label: "Aug", label2: "August" },
        { value: 9, label: "Sep", label2: "September" },
        { value: 10, label: "Oct", label2: "October" },
        { value: 11, label: "Nov", label2: "November" },
        { value: 12, label: "Dec", label2: "December" }
    ],
    vehicleYears: Constants.vehicleYears(),
    vehicleTransmission: [
        { value: 1, label: "Automatic" },
        { value: 2, label: "Manual" }
    ],
    drivetrainList: [
        { value: 1, label: "Front Wheel Drive", filterValue: "FWD" },
        { value: 2, label: "Rear Wheel Drive", filterValue: "RWD" },
        { value: 3, label: "4wd/Awd", filterValue: "AWD" }
    ],
    countries: [
        { value: "US", label: "US", label2: "United States of America" },
    ],
};

export const EMISSIONS_ZIPS = [
    98198, 98032, 98031, 98030, 98042, 98055, 98056, 98057, 98058, 98059, 98146, 98148, 98158, 98166, 98168, 98178,
    98188, 98134, 98008, 98101, 98102, 98103, 98104, 98105, 98106, 98107, 98108, 98109, 98112, 98115, 98116, 98117,
    98118, 98119, 98121, 98122, 98126, 98129, 98131, 98134, 98136, 98144, 98154, 98161, 98164, 98170, 98174, 98181,
    98185, 98190, 98191, 98195, 98199, 98004, 98005, 98006, 98007, 98008, 98033, 98034, 98039, 98040, 98052, 98027,
    98029, 98053, 98074, 98075, 98011, 98012, 98020, 98021, 98026, 98028, 98036, 98037, 98043, 98072, 98125, 98133,
    98155, 98177
];
export const DETAILING_ZIPS = [
    98004, 98005, 98006, 98007, 98008, 98011, 98012, 98020, 98021, 98026, 98028, 98033, 98034, 98036, 98037, 98039,
    98040, 98043, 98052, 98072, 98101, 98102, 98103, 98104, 98105, 98106, 98107, 98108, 98109, 98112, 98115, 98116,
    98117, 98118, 98119, 98121, 98122, 98125, 98126, 98129, 98131, 98133, 98134, 98136, 98144, 98154, 98155, 98161,
    98164, 98170, 98174, 98177, 98181, 98185, 98190, 98191, 98195, 98199
];

export const ACCOUNT_STATUS = {
    ACTIVE: 1,
    SUSPENDED: 2,
    DISABLED: 3,
    TEMPORARY: 4
};

export const REFERRAL_SOURCES = [
    "Google",
    "Facebook",
    "Friend/Family",
    "Radio",
    "News Article",
    "My Work",
    "TV",
    "YouTube",
    "Hulu",
    "Yelp",
    "Wrench Vans",
    "Firestone"
];

export const FLEET_QUOTES_TAB = {
    PRICING: 0,
    APPROVE: 1,
    SCHEDULE: 2,
    SAVED: 3,
    DENIED: 4
};

export const FLEET_APPOINTMENTS_TAB = {
    ACTIVE: 0,
    UPCOMING: 1,
    COMPLETE: 2,
};

export const FLEET_MANAGER_TAB = {
    VEHICLES: 0,
    EMPLOYEES: 1,
    LOCATIONS: 2,
    REGIONS: 3,
    HUBS: 4,
};

export const MODAL = {
    WIDTH: {
        SMALL: '250px',
        LARGE: '600px',
        EXTRA_LARGE: '900px',
        MAX: 'none'
    },
    HEIGHT: '100%',
    BREAK_POINT_MAX_WIDTH: '(max-width: 599px)',
    HEIGHT_LARGE: '550PX' // TODO ADD TO LM CONSTANTS
};

export const SERVICE_CODE = {
    EMISSIONS: 2473,
    DIAG: 140,
    DIAG2: 105,
    CUSTOM: 100,
    AC: 1362
};

export const LOCATION_TYPES = [
    { id: 1, name: 'Home' },
    { id: 2, name: 'Work' },
    { id: 3, name: 'Other' }
];

export const PARKING_TYPES = [
    { id: 1, name: 'Garage' },
    { id: 2, name: 'Driveway' },
    { id: 3, name: 'Parking Lot' }
];

export const PRODUCT = {
    DIAGNOSTIC: 10,
    FLEET_DIAGNOSTIC: 12
};

export const PRODUCT_GROUP = {
    DETAIL: 'detail',
    PARTNER: 'partner'
};

export const PRODUCT_TYPE: any = {
    UNKNOWN: 0,
    REPAIR: 1,
    MAINTENANCE: 2,
    INSPECTION: 3,
    UNSUPPORTED: 4
};

export const PRODUCT_CATEGORY_ID = {
    BRAKES_AND_TRACTION_CONTROL: 1000,
    DIAGNOSTIC: 1001,
    ENGINE_COOLING_EXHAUST: 1002,
    EXTERIOR_BODY: 1003,
    HEATING_AND_AIR_CONDITIONING: 1004,
    LIGHTING_AND_HORNS: 1005,
    MAINTENANCE: 1006,
    POWERTRAIN: 1007,
    STARTING_AND_CHARGING: 1008,
    STEERING_AND_SUSPENSION: 1009,
    TIRES: 1010,
    TRANSMISSION_AND_DRIVETRAIN: 1011,
    WINDOWS_AND_GLASS: 1012,
    WIPER_AND_WASHER_SYSTEM: 1013,
    OTHER: 1014,
    TOWING: 1015,
    DETAILING: 1016,
    CLUTCH: 1017,
    WINDSHIELD: 1018,
    PAINT: 1019
};

export const LICENSED_STATES = ["CO", "AZ", "DC", "CA", "MA", "FL", "MI", "GA", "MN", "IL", "MO", "NC", "NJ", "NV", "NY", "OR", "OH", "TX", "PA", "WA", "TN", "ID", "NM", "AL", "SC", "LA", "MS", "VA", "IN", "WI", "UT", "KY", "OK", "RI", "KS", "CT"];

export const quoteLabel = {
    fleetLabel: 'Schedule services',
    getQuoteLabel: 'Get a quote'
};

const WEBAPP3_MSG_SEPARATOR = '__';
export const WEBAPP3_MSG = {
    SEPARATOR: WEBAPP3_MSG_SEPARATOR,
    PREFIX: 'webapp3' + WEBAPP3_MSG_SEPARATOR,
    QUERY_STRING_SEPARATOR: '?',
    QUERY_PARAM_NAME_SEPARATOR: '=',
    QUERY_PARAM_VALUES_SEPARATOR: ',',
    NO_QS: '',
};

export const BULK_VEHICLE_TABLE = {
    PAGE_SIZE: 25,
};

export const MARKETS = [
    { market: 'seattle', label: 'Seattle', code: 'SEA', latitude: 47.608013, longitude: -122.335167 },
    { market: 'portland', label: 'Portland', code: 'PDX', latitude: 45.523064, longitude: -122.676483 },
    { market: 'san_diego', label: 'San Diego', code: 'SAN', latitude: 32.715736, longitude: -117.161087 },
    { market: 'phoenix', label: 'Phoenix', code: 'PHX', latitude: 33.448376, longitude: -112.074036 },
    { market: 'las_vegas', label: 'Las Vegas', code: 'LAS', latitude: 36.114647, longitude: -115.172813 },
    { market: 'dallas', label: 'Dallas', code: 'DAL', latitude: 32.7767, longitude: -96.7970 },
    { market: 'houston', label: 'Houston', code: 'IAH', latitude: 29.7604, longitude: -95.3698 },
    { market: 'austin', label: 'Austin', code: 'AUS', latitude: 30.2672, longitude: -97.7431 },
    { market: 'chicago', label: 'Chicago', code: 'ORD', latitude: 41.8781, longitude: -87.6298 },
    { market: 'sacramento', label: 'Sacramento', code: 'SMF', latitude: 38.5816, longitude: -121.4944 },
    { market: 'los_angeles', label: 'Los Angeles', code: 'LAX', latitude: 34.0522, longitude: -118.2437 },
    { market: 'orange_county', label: 'Orange County', code: 'ORL', latitude: 33.7175, longitude: -117.8311 },
    { market: 'oakland', label: 'Oakland', code: 'OAK', latitude: 37.8044, longitude: -122.2711 },
    { market: 'san_francisco', label: 'San Francisco', code: 'SFO', latitude: 37.7749, longitude: -122.4194 },
    { market: 'san_jose', label: 'San Jose', code: 'SJC', latitude: 37.3382, longitude: -121.8863 },
    { market: 'san_antonio', label: 'San Antonio', code: 'SAT', latitude: 29.4241, longitude: -98.4936 },
    { market: 'nashville', label: 'Nashville', code: 'BNA', latitude: 36.1627, longitude: -86.7816 },
    { market: 'atlanta', label: 'Atlanta', code: 'ATL', latitude: 33.7490, longitude: -84.3880 },
    { market: 'jacksonville', label: 'Jacksonville', code: 'JAX', latitude: 30.3322, longitude: -81.6557 },
    { market: 'orlando', label: 'Orlando', code: 'MCO', latitude: 28.5383, longitude: -81.3792 },
    { market: 'memphis', label: 'Memphis', code: 'MEM', latitude: 35.1495, longitude: -90.0490 },
    { market: 'tampa', label: 'Tampa', code: 'TPA', latitude: 27.9506, longitude: -82.4572 },
    { market: 'miami', label: 'Miami', code: 'MIA', latitude: 25.7617, longitude: -80.1918 },
    { market: 'raleigh', label: 'Raleigh', code: 'RDU', latitude: 35.7796, longitude: -78.6382 },
    { market: 'charlotte', label: 'Charlotte', code: 'CLT', latitude: 35.2271, longitude: -80.8431 },
    { market: 'denver', label: 'Denver', code: 'DEN', latitude: 39.742043, longitude: -104.991531 },
    { market: 'cleveland', label: 'Cleveland', code: 'CLE', latitude: 41.497447, longitude: -81.8459438 },
    { market: 'kansas_city', label: 'Kansas City', code: 'MCI', latitude: 39.0918352, longitude: -94.7158001 },
    { market: 'st_louis', label: 'St. Louis', code: 'STL', latitude: 38.630223, longitude: -90.196779 },
    { market: 'philadelphia', label: 'Philadelphia', code: 'PHL', latitude: 40.002413, longitude: -75.258452 },
    { market: 'washington_dc', label: 'Washington DC', code: 'DCA', latitude: 38.893512, longitude: -77.154999 },
    { market: 'detroit', label: 'Detroit', code: 'DTW', latitude: 42.352368, longitude: -83.380061 },
    { market: 'pittsburgh', label: 'Pittsburgh', code: 'PIT', latitude: 40.431283, longitude: -80.120924 },
    { market: 'albuquerque', label: 'Albuquerque', code: 'ABQ', latitude: 35.106766, longitude: -106.629181 },
    { market: 'birmingham', label: 'Birmingham', code: 'BHM', latitude: 33.543682, longitude: -86.779633 },
    { market: 'jackson', label: 'Jackson', code: 'JAN', latitude: 32.298756, longitude: -90.184807 },
    { market: 'charleston', label: 'Charleston', code: 'CHS', latitude: 32.784618, longitude: -79.940918 },
    { market: 'new_orleans', label: 'New Orleans', code: 'MSY', latitude: 29.951065, longitude: -90.071533 },
    { market: 'columbus', label: 'Columbus', code: 'CMH', latitude: 39.983334, longitude: -82.983330 },
    { market: 'richmond', label: 'Richmond', code: 'RIC', latitude: 37.540760, longitude: -77.433929 },
    { market: 'indianapolis', label: 'Indianapolis', code: 'IND', latitude: 39.768452, longitude: -86.156212 },
    { market: 'cincinnati', label: 'Cincinnati', code: 'CVG', latitude: 39.103119, longitude: -84.512016 },
    { market: 'norfolk', label: 'Norfolk', code: 'ORF', latitude: 36.846161, longitude: -76.285912 },
    { market: 'boston', label: 'Boston', code: 'BOS', latitude: 42.361145, longitude: -71.057083 },
    { market: 'milwaukee', label: 'Milwaukee', code: 'MKE', latitude: 43.038902, longitude: -87.906471 },
    { market: 'el_paso', label: 'El Paso', code: 'ELP', latitude: 31.772543, longitude: -106.460953 },
    { market: 'minneapolis', label: 'Minneapolis', code: 'MSP', latitude: 44.986656, longitude: -93.258133 },
    { market: 'salt_lake_city', label: 'Salt Lake City', code: 'SLC', latitude: 40.758701, longitude: -111.876183 },
    { market: 'louisville', label: 'Louisville', code: 'SDF', latitude: 38.328732, longitude: -85.764771 },
    { market: 'oklahoma_city', label: 'Oklahoma City', code: 'OKC', latitude: 35.481918, longitude: -97.508469 },
    { market: 'greensboro', label: 'Greensboro', code: 'GSO', latitude: 36.044659, longitude: -79.766235 },
    { market: 'tulsa', label: 'Tulsa', code: 'TUL', latitude: 36.153980, longitude: -95.992775 },
    { market: 'tucson', label: 'Tucson', code: 'TUS', latitude: 32.253460, longitude: -110.911789 },
    { market: 'fresno', label: 'Fresno', code: 'FAT', latitude: 36.746841, longitude: -119.772591 },
    { market: 'bakersfield', label: 'Bakersfield', code: 'BFL', latitude: 35.393528, longitude: -119.043732 },
    { market: 'new_york', label: 'New York', code: 'JFK', latitude: 40.730610, longitude: -73.935242 },
    { market: 'reno', label: 'Reno', code: 'RNO', latitude: 40.730610, longitude: -73.935242 },
    { market: 'killeen', label: 'Killeen', code: 'GRK', latitude: 31.117119, longitude: -97.727798 },
    { market: 'wichita', label: 'Wichita', code: 'ICT', latitude: 37.697948, longitude: -97.314835 },
    { market: 'corpus_christi', label: 'Corpus Christi', code: 'CRP', latitude: 27.800583, longitude: -97.396378 },
    { market: 'knoxville', label: 'Knoxville', code: 'TYS', latitude: 35.964668, longitude: -83.926453 },
    { market: 'huntsville', label: 'Huntsville', code: 'HSV', latitude: 34.738228, longitude: -86.601791 },
    { market: 'tallahassee', label: 'Tallahassee', code: 'TLH', latitude: 30.455000, longitude: -84.253334 },
    { market: 'chattanooga', label: 'Chattanooga', code: 'CHA', latitude: 35.045631, longitude: -85.309677 },
    { market: 'savannah', label: 'Savannah', code: 'SAV', latitude: 32.076176, longitude: -81.088371 },
    { market: 'columbia', label: 'Columbia', code: 'CAE', latitude: 34.00071, longitude: -81.03481 },
    { market: 'hartford', label: 'Hartford', code: 'BDL', latitude: 41.763710, longitude: -72.685097 },
    { market: 'lexington', label: 'Lexington', code: 'LEX', latitude: 38.047989, longitude: -84.501640 },
    { market: 'toledo', label: 'Toledo', code: 'TOL', latitude: 41.651031, longitude: -83.541939 },
    { market: 'providence', label: 'Providence', code: 'PVD', latitude: 41.825226, longitude: -71.418884 },
    { market: 'mobile', label: 'Mobile', code: 'MOB', latitude: 30.695366, longitude: -88.039894 },
    { market: 'buffalo', label: 'Buffalo', code: 'BUF', latitude: 42.880230, longitude: -78.878738 },
    { market: 'rochester', label: 'Rochester', code: 'ROC', latitude: 43.161030, longitude: -77.610924 },
    { market: 'grand_rapids', label: 'Grand Rapids', code: 'GRR', latitude: 42.963795, longitude: -85.670006 },
    { market: 'colorado_springs', label: 'Colorado Springs', code: 'COS', latitude: 38.846127, longitude: -104.800644 }
];

export const PARTNERS = {
    BRIDGESTONE: 'Bridgestone',
};

export const PARTNER_ID = {
    SILVERROCK: 1020,
    GWC: 1025,
    CARPARTS: 1026,
    AMERICANAUTOSHIELD: 1027,
    BRIDGESTONE: 1033
};

export const CANCELLATION_REASONS = [
    { value: 110, display: 'Mechanic was late or no show' },
    { value: 111, display: 'I will get my car serviced another time' },
    { value: 112, display: 'I need my appointment sooner than what is available' },
    { value: 113, display: 'The price is too high' },
    { value: 114, display: 'I plan to have my car serviced somewhere else' },
    { value: 115, display: 'The repairs/maintenance is resolved/I fixed myself' }
];

export const COMMUNICATION_PREFERENCE_IDS = {
    "text_promotion": 1103,
    "email_promotion": 1012
};

export const VEHICLE_SELECTOR_TYPES = {
    VIN: 'VIN',
    LICENSE_PLATE: 'License plate'
};

export const ORGANIZATION_TYPES = {
    HOUSEHOLD: 1,
    FLEET: 2,
    PARTNER: 3,
    WRENCH: 4
};

export const PHONE_NUMBER_EXTRACTION_MODE = {
    parsePhoneNumber: "parsePhoneNumber",
    nonParsePhoneNumber: "nonParsePhoneNumber"
};

export const DEFAULT_CURRENCY_CODE = 'USD';
export const SHOW_ADDON_STEP = true;

export const EXCEPTION_TYPES = {
    USER_NOT_FOUND: 'UserNotFoundException',
    NOT_AUTHENTICATED: 'The user is not authenticated',
    PASSWORD_RESET_REQUIRED: 'PasswordResetRequiredException',
    NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
    INCORRECT_USER_PW: 'NotAuthorizedException'
};
export const HIDE_TERMS = false;
export const SERVICE_STATUS_DECLINED = 4;
export const DEFAULT_COUNTRY = 'us';
export const ACCOUNT_EXISTS_ERROR = 'An account with this email already exists, Please login or reset your password.';
export enum CUSTOMER_TYPE {
    DAN = 'dan',
}
export const DAN_PAYMENT_TYPE = 48;
export enum API_KEYS {
    GOOGLE_MAPS = 'AIzaSyAR4wKb8h8cyXyMWtjEFT8VFxuPRoI6DG0'
}
export const FAB_NAVIGATION = false;
export enum TYRE_METADATA {
    PART_NAME_ID = 2355,
    POSITION_ID = 1,
    PRODUCT_ID = 10003
}

export const VEHICLE_SELECTOR_OPTIONS = {
    FUEL_TYPE: false,
    DRIVING_WHEELS: false,
};

export const FUEL_TYPES = [
    {label: "Petrol", value: 1},
    {label: "Diesel", value: 2},
    {label: "Electric", value: 3},
    {label: "Hybrid", value: 4},
    {label: "CNG", value: 5},
    {label: "LPG", value: 6},
    {label: "Hydrogen", value: 8},
];

export const FIXED_APPOINTMENT_SLOTS = [8, 10, 12, 14];
export const DEFAULT_TIMEZONE: string = "PDT/PST";

export enum WORK_ORDER_STATUS {
    PRICING = 1,
    WAITING_FOR_USER = 2,
    READY_TO_SCHEDULE = 3,
    PENDING_APPROVAL = 4,
    PENDING_PARTNER = 5,
    PARTS_ORDERING = 6,
    REVIEW_REQUIRED = 7,
    SCHEDULED = 8,
    ENROUTE = 9,
    WORKING = 10,
    RESCHEDULE_NEEDED = 11,
    ON_HOLD = 12,
    COMPLETE = 13,
    CANCELLED = 14,
    SAVED = 15,
}

export const DISABLE_INVOICE_PAGE = false;

export const SHOW_PHONE_TYPE_ICON = true;

export const PHONE_FIELD_VALUES = {
    regx: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    placeholder: "(555) 367-9436"
};
export const LOGO_URL = "images/wrench-logo-stacked-white.svg";

export const NAME_REGEX = /^[a-zA-Z0-9 .-]+$/;

export enum PPM_CONTRACT_STATUS {
    ACTIVE = 1,
    CANCELLED = 2
}

export enum PPM_CONTRACT_SERVICE_STATUS {
    ACTIVE = 1,
    CANCELLED = 2,
    RESERVED = 3
}

export enum BRAND {
    WRENCH = 1,
    YM
}
